const WEB_THEME = {
  primary: "#bfd508",
  primaryHover: "#000319",
  heading: "#000319",
  text: "#6f7484",
  textLight: "#8a8f9d",
  white: "#ffffff",
  softBg: "#f3f3f5",
  border: "#ececf1",
  success: "#52c41a",
  warning: "#faad14",
  error: "#f5222d",
  info: "#1890ff",
};

export const APP_COLORS = {
  primary: WEB_THEME.primary,
  primaryHover: WEB_THEME.primaryHover,
  primaryLight: WEB_THEME.softBg,
  primarySoft: WEB_THEME.softBg,
  secondary: WEB_THEME.primaryHover,
  secondaryAlt: WEB_THEME.primaryHover,
  accent: WEB_THEME.primary,

  text: WEB_THEME.text,
  textDark: WEB_THEME.heading,
  textSecondary: WEB_THEME.text,
  textMuted: WEB_THEME.textLight,

  white: WEB_THEME.white,
  black: "#000000",
  pageBg: WEB_THEME.softBg,
  surface: WEB_THEME.white,
  surfaceSoft: WEB_THEME.softBg,
  border: WEB_THEME.border,
  borderLight: WEB_THEME.border,

  success: WEB_THEME.success,
  successDark: "#389e0d",
  warning: WEB_THEME.warning,
  warningDark: "#d97706",
  danger: WEB_THEME.error,
  error: WEB_THEME.error,
  errorDark: "#cf1322",
  info: WEB_THEME.info,
  infoDark: "#1677ff",
};

export const APP_FONT_FAMILY = {
  en: "var(--font-family-en)",
  ar: "var(--font-family-ar)",
};

export const APP_ANTD_THEME = {
  token: {
    colorPrimary: APP_COLORS.primary,
    colorPrimaryHover: APP_COLORS.primaryHover,
    colorSuccess: APP_COLORS.success,
    colorWarning: APP_COLORS.warning,
    colorError: APP_COLORS.error,
    colorInfo: APP_COLORS.info,
    colorText: APP_COLORS.textDark,
    colorTextSecondary: APP_COLORS.textSecondary,
    colorBgLayout: APP_COLORS.pageBg,
    colorBgContainer: APP_COLORS.surface,
    colorBorder: APP_COLORS.border,
    borderRadius: 12,
    controlHeight: 40,
    controlHeightLG: 44,
    fontFamily: APP_FONT_FAMILY.en,
    fontSize: 15,
    fontSizeSM: 13,
    fontSizeLG: 17,
  },
  components: {
    Button: {
      colorPrimary: APP_COLORS.primary,
      colorPrimaryHover: APP_COLORS.primaryHover,
      colorPrimaryActive: APP_COLORS.primaryHover,
      primaryColor: APP_COLORS.primaryHover,
      borderRadius: 14,
      controlHeight: 40,
      controlHeightLG: 44,
      paddingInline: 18,
      fontWeight: 700,
    },
    Card: {
      borderRadiusLG: 18,
    },
    Table: {
      headerBg: APP_COLORS.surfaceSoft,
      headerColor: APP_COLORS.textDark,
    },
  },
};
